import { useCallback, useMemo } from 'react';
import useCookie from './useCookie';

const RECENT_INSIGHTS_KEY = 'ht_mru';
const RECENT_INSIGHTS_MAX = 5;

export default function useRecentInsights() {
  const { cookieValue, setCookie } = useCookie(RECENT_INSIGHTS_KEY);

  const recentInsights = useMemo(() => cookieValue.split(','), [cookieValue]);

  const addRecentInsight = useCallback(
    (insightId: string) => {
      if (recentInsights[0] === insightId) {
        return;
      }
      const otherInsights =
        recentInsights.filter((id) => id !== insightId) ?? [];
      setCookie(
        [insightId, ...otherInsights].slice(0, RECENT_INSIGHTS_MAX).join(',')
      );
    },
    [recentInsights, setCookie]
  );

  return { recentInsights, addRecentInsight };
}
